// ProductFilters.jsx
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ProductList from "./productList.jsx";

const ProductFilters = ({ products, initialCategory }) => {
    const navigate = useNavigate();
    const location = useLocation();

    // State for filters. initialCategory is passed from props.
    const [selectedCategory, setSelectedCategory] = useState(initialCategory || "");
    const [selectedMaterial, setSelectedMaterial] = useState("");
    const [selectedStyle, setSelectedStyle] = useState("");
    const [sortOption, setSortOption] = useState("default");

    // Reset filters when initialCategory (from URL) changes
    useEffect(() => {
        setSelectedCategory(initialCategory || "");
        setSelectedMaterial("");
        setSelectedStyle("");
        setSortOption("default");
    }, [initialCategory]); // Only re-run if initialCategory changes

    // Function to get unique options for filters from the *current* set of products
    const getUniqueOptions = (key) => {
        // Use the `products` prop, which are already filtered by section
        return [...new Set(products.map((p) => p[key]).filter(Boolean))] // Filter out undefined/null
            .sort((a, b) => String(a).localeCompare(String(b))); // Sort alphabetically
    };

    const handleCategoryChange = (e) => {
        const newCategory = e.target.value;
        setSelectedCategory(newCategory);

        // Get the current section from the URL path (e.g., "livingroom")
        const currentSection = location.pathname.split("/")[1]?.toLowerCase();

        // Construct the new URL path
        // If a specific category is selected, use its lowercase, hyphenated version
        // If "All Categories" is selected (empty string), navigate to the "all" slug for that section
        const categorySlug = newCategory
            ? newCategory.toLowerCase().replace(/\s+/g, '-') // Convert "Coffee Tables" to "coffee-tables"
            : "all"; // Use "all" as a conventional slug for showing all in a section

        // Example path: /livingroom/sofas or /restaurant/all
        navigate(`/${currentSection}/${categorySlug}`);
    };

    // Filter products based on selected options
    const filteredProducts = products
        // NO LONGER filter by product.section here, as `products` prop is already section-specific
        .filter((product) => (selectedCategory ? product.category === selectedCategory : true))
        .filter((product) => (selectedMaterial ? product.material === selectedMaterial : true))
        .filter((product) => (selectedStyle ? product.style === selectedStyle : true));

    console.log("All Products (received by ProductFilters):", products); // Log the products received
    console.log("Filtered products (after applying ProductFilters criteria):", filteredProducts);


    return (
        <div className="p-4 space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <select
                    value={selectedCategory}
                    onChange={handleCategoryChange}
                    className="p-2 border rounded"
                >
                    <option value="">All Categories</option>
                    {getUniqueOptions("category").map((category) => (
                        <option key={category} value={category}>
                            {category}
                        </option>
                    ))}
                </select>

                <select
                    value={selectedMaterial}
                    onChange={(e) => setSelectedMaterial(e.target.value)}
                    className="p-2 border rounded"
                >
                    <option value="">All Materials</option>
                    {getUniqueOptions("material").map((material) => (
                        <option key={material} value={material}>
                            {material}
                        </option>
                    ))}
                </select>

                <select
                    value={selectedStyle}
                    onChange={(e) => setSelectedStyle(e.target.value)}
                    className="p-2 border rounded"
                >
                    <option value="">All Styles</option>
                    {getUniqueOptions("style").map((style) => (
                        <option key={style} value={style}>
                            {style}
                        </option>
                    ))}
                </select>

                {/* Sort by price removed */}
            </div>

            <ProductList products={filteredProducts} />
        </div>
    );
};

export default ProductFilters;
